var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-list-item',{attrs:{"title":_vm.title},on:{"click":function($event){return _vm.setPlayButton(_vm.index)}}},[_c('img',{attrs:{"slot":"media","src":'./static/images/play/' + _vm.index + '.png',"alt":_vm.title},slot:"media"})])}
var staticRenderFns = []

export { render, staticRenderFns }